import {
    Page,
    Document,
    PDFViewer,
    View,
    Text,
    StyleSheet,
} from "@react-pdf/renderer";
// import { Request } from "../../hooks/Request";

const styles = StyleSheet.create({
    page: {
        padding: "20px 20px",
        fontSize: 8.5,
    },
    seccion: {
        marginTop: 20,
        marginHorizontal: 30,
    },
    title: {
        fontSize: 11,
        textAlign: "center",
        marginBottom: 10,
        fontWeight: "bold",
        color: "#696969"
    },
    datos: {
        flexDirection: "col",
        alignItems: "flex-start",
    },
    detalle: {
        flexDirection: "col",
        paddingHorizontal: 10,
    },

    table: {
        marginTop: 4,
        borderColor: "#000",
        borderStyle: "solid",
        borderBottom: 1
    },
    tableRowHeader: {
        flexDirection: "row",
        backgroundColor: "#d9d9d9",
        height: 40,
        borderTop: 1,
        fontWeight: "bold",
    },
    cell: {
        borderLeft: 1,
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
    },
    contenedor: {
        flexDirection: "row",
        alignSelf: "center",
        alignItems: "center",
    },
    text: {
        fontWeight: "normal",
    },
    tableRow: {
        flexDirection: "row",
        borderColor: "#000",
        borderStyle: "solid",
        borderLeft: 1,
        borderRight: 1,
    },
    cellRow: {
        // flex: 1,
        textAlign: "center",
        fontWeight: "normal",
        alignSelf: "center",
        minHeight: 24,
        maxHeight: 32,
        borderRight: 1,
        justifyContent: "center",
    },
    footer: {
        position: "absolute",
        bottom: 40,
        left: 0,
        right: 20,
        textAlign: "center",
    },
});

const data = {
    Importador: {
        numero: "2025-0038",
        fecha: "16/06/2025",
        hojaTrabajo: "SCZ-2025-0038",
        nombreBanco: "BANCO UNION",
        cuentaBanco: "1045331464",
        declaracion: "-",
        facturaComercial: "B2407874-E",
        proformaPrveedor: "HJ-W-DM240805",
        nombre: "MOTOMAX S.R.L.",
        numerDespacho: "-",
        dim: "-",
    },
    tabla: [
        {
            descripcion: "Conciliacion de deposito bancario",
            numero: "2025-0026",
            cantidad: "185",
            contabilidad: "si",
            comercial: "",
            org: "si",
            leg: "",
            elecOrg: "",
            fotocopia: "",
        },
        {
            descripcion: "Nota de Cobranza de despacho Aduanero",
            numero: "2025-0026",
            cantidad: "1",
            contabilidad: "si",
            comercial: "",
            org: "si",
            leg: "",
            elecOrg: "",
            fotocopia: "",
        },
        {
            descripcion: "Recibo Único de Pago",
            numero: "2025201R31820",
            cantidad: "1",
            contabilidad: "si",
            comercial: "",
            org: "",
            leg: "",
            elecOrg: "si",
            fotocopia: "",
        },
        {
            descripcion: "DIM Original",
            numero: "",
            cantidad: "145",
            contabilidad: "si",
            comercial: "",
            org: "si",
            leg: "",
            elecOrg: "",
            fotocopia: "",
        },
        {
            descripcion: "Factura Agencia",
            numero: "",
            cantidad: "145",
            contabilidad: "si",
            comercial: "",
            org: "",
            leg: "",
            elecOrg: "si",
            fotocopia: "",
        },
        {
            descripcion: "Recibo de Pago al Banco",
            numero: "",
            cantidad: "145",
            contabilidad: "si",
            comercial: "",
            org: "",
            leg: "",
            elecOrg: "si",
            fotocopia: "",
        },
        {
            descripcion: "Planilla de despacho Aduanero",
            numero: "",
            cantidad: "145",
            contabilidad: "si",
            comercial: "",
            org: "si",
            leg: "",
            elecOrg: "",
            fotocopia: "",
        },
        {
            descripcion: "Factura de Almacenaje",
            numero: "",
            cantidad: "145",
            contabilidad: "si",
            comercial: "",
            org: "",
            leg: "",
            elecOrg: "si",
            fotocopia: "",
        },
        {
            descripcion: "DIM Original para Comercial",
            numero: "",
            cantidad: "145",
            contabilidad: "si",
            comercial: "si",
            org: "si",
            leg: "",
            elecOrg: "",
            fotocopia: "",
        },
        {
            descripcion: "DIM Original para Tramite de Alcaldia",
            numero: "",
            cantidad: "145",
            contabilidad: "si",
            comercial: "si",
            org: "si",
            leg: "",
            elecOrg: "",
            fotocopia: "",
        },
        {
            descripcion: "DIM Original para Tramite en Transito",
            numero: "",
            cantidad: "145",
            contabilidad: "si",
            comercial: "si",
            org: "si",
            leg: "",
            elecOrg: "",
            fotocopia: "",
        },
        {
            descripcion: "Factura Agencia",
            numero: "",
            cantidad: "145",
            contabilidad: "si",
            comercial: "si",
            org: "",
            leg: "",
            elecOrg: "",
            fotocopia: "si",
        },
    ]
};

function ProofDeliveryDocument({ procedure, documentData }) {
 console.log("Datos recibidos en ProofDeliveryDocument 222:", documentData);
    const MyDoc = ({ data }) => {

        const currentDate = new Date().toLocaleDateString("es-BO", {
            day: "numeric",
            month: "long",
            year: "numeric",
        });
        const parsedDocumentData = documentData.map(item => JSON.parse(item.description));
        return (
            <Document>
                <Page size="LETTER" style={styles.page}>
                    <View style={styles.seccion}>
                        <Text style={styles.title}>
                            Constancia de Entrega de Documentos
                        </Text>
                        <View style={styles.datos}>
                            <View style={{ ...styles.detalle, paddingBottom: 10 }}>
                                <Text >Señor (a):</Text>
                                <Text style={{ fontWeight: "bold" }}>{data.Importador.nombre}</Text>
                            </View>
                            <View style={styles.detalle}>
                                <Text >En primer lugar, gracias por el gusto y la confianza prestada en nuestra compañia. A continuacion le damos a conocer los documentos que se les esta entregando en <Text>FISICO</Text> </Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.seccion}>
                        <View style={styles.table}>
                            <View style={styles.tableRowHeader}>
                                <View style={{ ...styles.cell, flex: 4, }}>
                                    <View style={{ ...styles.contenedor }}>
                                        <Text>DESCRIPCION</Text>
                                    </View>
                                </View>
                                <View style={{ ...styles.cell, flex: 3, }}>
                                    <View style={{ ...styles.contenedor }}>
                                        <Text>NUMERO</Text>
                                    </View>
                                </View>
                                <View style={{ ...styles.cell, flex: 3, }}>
                                    <View style={{ ...styles.contenedor }}>
                                        <Text>CANTIDAD</Text>
                                    </View>
                                </View>
                                <View style={{ ...styles.cell, flex: 4, }}>
                                    <View style={{ flexDirection: "column", width: "100%", height: "100%" }}>
                                        <View style={{ ...styles.cell, flex: 1, borderBottom: 1, borderLeft: 0 }}>
                                            <View style={{ ...styles.contenedor, }}>
                                                <Text>DEPARTAMENTO</Text>
                                            </View>
                                        </View>
                                        <View style={{ flexDirection: "row", flex: 1, }}>
                                            <View style={{ ...styles.cell, flex: 1, borderLeft: 0, backgroundColor: "#f2f2f2", }}>
                                                <View style={{ ...styles.contenedor, flex: 1, fontSize: 7 }}>
                                                    <Text style={{ ...styles.text, }}>CONTABILIDAD</Text>
                                                </View>
                                            </View>
                                            <View style={{ ...styles.cell, flex: 1, backgroundColor: "#f2f2f2", }}>
                                                <View style={{ ...styles.contenedor, flex: 1, fontSize: 7, borderRight: 0 }}>
                                                    <Text style={{ ...styles.text, }}>COMERCIAL</Text>
                                                </View>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                                <View style={{ ...styles.cell, flex: 4, }}>
                                    <View style={{ flexDirection: "column", width: "100%", height: "100%" }}>
                                        <View style={{ ...styles.cell, flex: 1, borderBottom: 1, borderLeft: 0, borderRight: 1 }}>
                                            <View style={{ ...styles.contenedor, }}>
                                                <Text>ESTADO DE DOCUMENTO</Text>
                                            </View>
                                        </View>
                                        <View style={{ flexDirection: "row", flex: 1, }}>
                                            <View style={{ ...styles.cell, flex: 1, borderLeft: 0, backgroundColor: "#f2f2f2", }}>
                                                <View style={{ ...styles.contenedor, flex: 1, fontSize: 7 }}>
                                                    <Text style={{ ...styles.text, }}>ORG</Text>
                                                </View>
                                            </View>
                                            <View style={{ ...styles.cell, flex: 1, backgroundColor: "#f2f2f2", }}>
                                                <View style={{ ...styles.contenedor, flex: 1, fontSize: 7 }}>
                                                    <Text style={{ ...styles.text, }}>LEG</Text>
                                                </View>
                                            </View>
                                            <View style={{ ...styles.cell, flex: 1, backgroundColor: "#f2f2f2", }}>
                                                <View style={{ ...styles.contenedor, flex: 1, fontSize: 7 }}>
                                                    <Text style={{ ...styles.text, }}>ELEC. ORG.</Text>
                                                </View>
                                            </View>
                                            <View style={{ ...styles.cell, flex: 1, borderRight: 1, backgroundColor: "#f2f2f2", }}>
                                                <View style={{ ...styles.contenedor, flex: 1, fontSize: 7, }}>
                                                    <Text style={{ ...styles.text, }}>FOTOCOPIA</Text>
                                                </View>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </View>
                            {parsedDocumentData.concat([...Array(0)]).map((item, index) => (
                                <View
                                    key={index}
                                    style={{
                                        ...styles.tableRow,
                                        backgroundColor: index % 2 === 0 ? "#fff" : "#f0f0f0",
                                    }}
                                >
                                    <View style={{ ...styles.cellRow, width: 113.6 }}>
                                        <Text style={{ textAlign: "left", padding: 2 }}>{item?.descripcion || ""}</Text>
                                    </View>
                                    <View style={{ ...styles.cellRow, width: 85.55 }}>
                                        <Text>{item?.numero || ""}</Text>
                                    </View>
                                    <View style={{ ...styles.cellRow, width: 85.55 }}>
                                        <Text>{item?.cantidad || ""}</Text>
                                    </View>
                                    <View style={{ ...styles.cellRow, width: 56.8 }}>
                                        <Text>{item?.contabilidad || ""}</Text>
                                    </View>
                                    <View style={{ ...styles.cellRow, width: 56.8 }}>
                                        <Text>{item?.comercial || ""}</Text>
                                    </View>
                                    <View style={{ ...styles.cellRow, alignItems: "center", width: 28.2 }}>
                                        <Text>{item?.org || ""}</Text>
                                    </View>
                                    <View style={{ ...styles.cellRow, alignItems: "center", width: 28.2 }}>
                                        <Text>{item?.leg || ""}</Text>
                                    </View>
                                    <View style={{ ...styles.cellRow, alignItems: "center", width: 28.2 }}>
                                        <Text>{item?.elecOrg || ""}</Text>
                                    </View>
                                    <View style={{ ...styles.cellRow, alignItems: "center", borderRight: 0, width: 27.2 }}>
                                        <Text>{item?.fotocopia || ""}</Text>
                                    </View>
                                </View>
                            ))}
                        </View>
                        <View
                            style={{
                                flex: 1,
                                borderBottom: 1,
                                borderLeft: 1,
                                borderRight: 1,
                                borderColor: "#000",
                                borderStyle: "solid",
                                paddingBottom: 15,
                            }}
                        >
                            <Text style={{ textAlign: "center", fontSize:10, paddingTop:2}}>
                                Adjuntamos fotocopias de documentos que acompañan al trámite
                            </Text>
                        </View>
                    </View>
                    <View style={{ ...styles.seccion }}>
                        <Text style={{ alignItems: "flex-start", flex: 1, paddingHorizontal: 10, gap: 20 }}>La documentación soporte del despacho Aduanero, se encuentra detallada en la página de documentos adicionales de la declaración de mercancías (DIM){" "}
                            <Text style={{ textDecoration: "underline", fontStyle: "italic" }}>
                                de acuerdo al artículo 45° inciso e) de la ley general de Aduanas N° 1990 se encuentra bajo nuestra custodia.
                            </Text>
                        </Text>
                    </View>
                    <View style={styles.footer}>
                        <View style={{ ...styles.seccion, }}>
                            <View style={{ flexDirection: "row", padding: 2, }}>
                                <View style={{ alignItems: "flex-start", flex: 1, paddingLeft: 30, gap: 20 }}>
                                    <Text>Firma:........................................................</Text>
                                    <Text>Recibido por:.............................................</Text>
                                    <View>
                                        <Text>Fecha:.......................................................</Text>
                                        <Text style={{ fontSize: 7 }}>Elaborado en fecha {currentDate}</Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>

                </Page>
            </Document>
        );
    };
    return (
        <div>
            {data && (
                <PDFViewer
                    style={{
                        width: 900,
                        height: window.innerHeight - 100,
                    }}
                >
                    <MyDoc data={data} />
                </PDFViewer>
            )}
        </div>
    );
}

export default ProofDeliveryDocument;
